module.exports = __webpack_public_path__ + "static/media/laughter-badge.bab40bb6.svg";